const options = {
  5: "bg-lime-300/5",
  10: "bg-lime-300/10",
  25: "bg-lime-300/25",
  50: "bg-lime-300/50",
  75: "bg-lime-300/75",
  90: "bg-lime-300/90",
  100: "bg-lime-300",
};

const from = {
  5: "from-lime-300/5",
  10: "from-lime-300/10",
  25: "from-lime-300/25",
  50: "from-lime-300/50",
  75: "from-lime-300/75",
  90: "from-lime-300/90",
  100: "from-lime-300",
};

export default function getBackgroundLime300(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
